var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col md:flex-row -mx-6"},_vm._l((_vm.testimonials),function(item){return _c('div',{key:item.name,staticClass:"px-6 w-full md:w-1/2 mb-8 md:mb-0"},[_c('testimonials-list-card',{attrs:{"item":item}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }